import { useMemo } from 'react';

import useCacheAdoption from '@/hooks/useCacheAdoption';
import { useUserContext } from '@/modules/auth/hooks/useUser';

import { AgendaTemplateFragment } from '../graphql/fragments/generated/AgendaTemplate';
import { useAgendaTemplatesQuery } from '../graphql/queries/generated/agendaTemplates';

const useAgendaTemplates = () => {
  const user = useUserContext();
  const [{ fetching, data, error }] = useAgendaTemplatesQuery({
    variables: {
      filters: {
        createdByIds: [user.id],
      },
      first: -1,
    },
  });

  const templates = useCacheAdoption(
    data?.agendaItemTemplates.edges?.map((edge) => edge.node) ?? [],
  ) as AgendaTemplateFragment[];

  const indexedTemplates = useMemo(() => {
    if (!templates) return undefined;

    return templates.reduce(
      (acc, template) => {
        acc[template.id] = template;

        return acc;
      },
      {} as Record<string, AgendaTemplateFragment>,
    );
  }, [templates]);

  return {
    fetching,
    error,
    templates: templates.length > 0 ? templates : undefined,
    indexedTemplates,
  };
};

export default useAgendaTemplates;
